import React from 'react'
import HomePage from '../pages/HomePage'

function Home() {
  return (
    <HomePage/>
  )
}

export default Home